export enum SocialPlatform {
    INSTAGRAM   = "instagram",
    TIKTOK      = "tiktok",
    LINKEDIN    = "linkedin",
    X           = "x",
    GITHUB      = "github",
    YOUTUBE     = "youtube",
}

export enum SocialPlatformLabel {
    INSTAGRAM   = "Instagram",
    TIKTOK      = "TikTok",
    LINKEDIN    = "LinkedIn",
    X           = "X (Twitter)",
    GITHUB      = "GitHub",
    YOUTUBE     = "YouTube",
}

export enum SocialPlatformUrl {
    INSTAGRAM   = "https://instagram.com/",
    TIKTOK      = "https://www.tiktok.com/@",
    LINKEDIN    = "https://www.linkedin.com/in/",
    X           = "https://x.com/",
    GITHUB      = "https://github.com/",
    YOUTUBE     = "https://youtube.com/",
}

export interface UserProfile {
    id:                 string;
    user_id:            number;
    display_name:       string;
    created_at:         number;
    social_platforms:   Partial<Record<SocialPlatform, string>>; 
    description?:       string;
};

export type SocialMeta = {
    key:        SocialPlatform;
    label:      SocialPlatformLabel;
    urlPrefix:  SocialPlatformUrl;
};

export const SOCIALS: SocialMeta[] = [
    {key: SocialPlatform.INSTAGRAM, label: SocialPlatformLabel.INSTAGRAM,   urlPrefix: SocialPlatformUrl.INSTAGRAM},
    {key: SocialPlatform.TIKTOK,    label: SocialPlatformLabel.TIKTOK,      urlPrefix: SocialPlatformUrl.TIKTOK},
    {key: SocialPlatform.LINKEDIN,  label: SocialPlatformLabel.LINKEDIN,    urlPrefix: SocialPlatformUrl.LINKEDIN},
    {key: SocialPlatform.X,         label: SocialPlatformLabel.X,           urlPrefix: SocialPlatformUrl.X},
    {key: SocialPlatform.GITHUB,    label: SocialPlatformLabel.GITHUB,      urlPrefix: SocialPlatformUrl.GITHUB},
    {key: SocialPlatform.YOUTUBE,   label: SocialPlatformLabel.YOUTUBE,     urlPrefix: SocialPlatformUrl.YOUTUBE},
];

export interface RankingEntry {
    score: number;
    ranking: number;
    ranking_type: string;
}

export interface UserRankings {
    weekly_rankings: Record<string, RankingEntry>;
}

export type ProfileRankingsResponse = Record<string, UserRankings>;
